import React from 'react';
import { Login, LoginForm, TextInput, required } from 'react-admin';

const CustomLogin = () => (
  <Login>
    <LoginForm>
      <TextInput
        autoFocus
        source="badge"
        label="Badge"
        autoComplete="badge"
        type="badge"
        validate={required()}
      />
    </ LoginForm>
  </Login>
);

export default CustomLogin;
